import { StringUtils } from '../../utils/string-utils';
import { Graphic } from './graphic';
import { Dimension, Location, Rectangle, Resizable, TextAlignType, TextAlignTypes, TextLocation } from './meme.types';

/**
 * Text of a meme that reside in a canvas
 */
export class MemeText extends Graphic implements Resizable {
    TYPE = 'MemeText';
    id: string;
    private textLocation: TextLocation;
    private text: string;
    maxMaxFontSize = 40;
    fontSize = 40;
    fontGap = 15;
    hasLineWidth = true;
    fontColor = 'white';
    fontFamily = 'impact';
    textAlign: TextAlignType = TextAlignTypes.CENTER;
    boundingRectangle: Rectangle;
    editPanelShown = false;
    capitalized = true;
    topOffset = 5;

    constructor(text: string, location: TextLocation) {
        super();
        this.text = text;
        this.textLocation = location;
        this.id = 'x-' + StringUtils.uuid();
    }

    getElementRect(): Rectangle {
        const el = document.getElementById(this.id);
        const rect = el.getBoundingClientRect();
        return {
            width: rect.width,
            height: rect.height,
            x: rect.left,
            y: rect.top,
        };
    }

    getType() {
        return this.TYPE;
    }

    resize(mouseLocation: Location) {
        const containerRect = this.getElementRect();
        this.textLocation.width = mouseLocation.x - containerRect.x;
        this.textLocation.width = this.textLocation.width < 100 ? 100 : this.textLocation.width;
    }

    move(location: Location) {
        this.textLocation.x = location.x;
        this.textLocation.y = location.y;
    }

    moveToView(viewBound: Dimension) {
        this.textLocation.x = 0;
        this.textLocation.y = 0;
    }

    showEditPanel() {
        this.editPanelShown = true;
    }

    toggleEditPanel() {
        this.editPanelShown = !this.editPanelShown;
    }

    hideEditPanel() {
        this.editPanelShown = false;
    }

    getEditPanelState() {
        return this.editPanelShown;
    }

    setMaxFontSize(size: number) {
        this.maxMaxFontSize = size;
    }

    setFontSize(size: number) {
        this.fontSize = size;
    }

    setFontGap(gap: number) {
        this.fontGap = gap;
    }

    getFontSize() {
        return this.fontSize;
    }

    getMaxFontSize(): number {
        return this.maxMaxFontSize;
    }

    getFontGap(): number {
        return this.fontGap;
    }

    getBoundingRect(): Rectangle {
        return this.boundingRectangle;
    }

    setBoundingRect(rect: Rectangle) {
        this.boundingRectangle = rect;
    }

    getLocation(): TextLocation {
        return this.textLocation;
    }

    getTopOffset(): number {
        return this.topOffset;
    }

    getText() {
        return (this.capitalized) ? this.text.toUpperCase() : this.text;
    }

    getCapitalized() {
        return this.capitalized;
    }

    setCapitalized(capitalized: boolean) {
        this.capitalized = capitalized;
    }

    setText(str: string) {
        this.text = str;
    }
}
